import { ReferralData, ReferralGetListQuery } from 'chaika-frontend-types/frontend-cms';

import { LongList } from '@store/abstract/LongList';

export class ReferralList extends LongList<ReferralData, ReferralData> {
    public searchParams: ReferralGetListQuery = {};
    public readonly limit: number = 50;

    public setSearchParams(params: ReferralGetListQuery): void {
        this.searchParams = params;
    }

    protected create(params: ReferralData): ReferralData {
        return params;
    }
}
